exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.number1[data-v-bc8b035c]{\r\n  display: -webkit-box;\r\n  display: -webkit-flex;\r\n  display: flex;\r\n  -webkit-box-align: center;\r\n  -webkit-align-items: center;\r\n          align-items: center;\r\n  color: #323233;\r\n  font-size: 0.37333rem;\n}\n.number1 p[data-v-bc8b035c]{\r\n  padding: 10px 15px;\r\n  color: #323233;\r\n  font-size: 0.37333rem;\n}\r\n", ""]);

// exports
